export default "__VITE_ASSET__P95X6RRP__"